<template>
  <a-card :bordered="false" :loading="pageLoading" v-if="pageLoading"
    >Loading ...
  </a-card>
  <a-form :form="form" ref="forms" v-else>
    <a-row :gutter="16">
      <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
        <a-form-item label="Report Date">
          <a-date-picker
            placeholder="Select Date"
            :disabled="true"
            :format="getDefaultDateFormat"
            v-decorator="[
              'tanggal_pelaporan',
              {
                rules: [{ required: true }],
                initialValue: initialData.tanggal_pelaporan,
              },
            ]"
          />
        </a-form-item>

        <a-form-item label="End User CC">
          <a-select
            showSearch
            allowClear
            :filter-option="filterOptionTlc"
            option-filter-prop="children"
            v-decorator="['end_user', { rules: [{ required: true }],initialValue: initialData.id_user_cc, }]"
            :disabled="dataList.length>0"
          >
            <a-select-option v-for="user in getEndUserCCFiltered" :key="user.id_user_cc"
              >{{ user.nama }} ({{user.type_cc}} / {{ formatRupiah(user.limit_kredit) }})</a-select-option
            >
          </a-select>
        </a-form-item>

        <!-- <a-form-item label="Jenis Anggaran">
          <a-select
            showSearch
            :not-found-content="null"
            option-filter-prop="children"
            v-decorator="[
          'jenis_anggaran',
          {
            rules: [{ required: true }],
            initialValue: initialData.jenis_anggaran,
          },
        ]"
            @change="handleJenisAnggaran"
            :disabled="dataList && dataList.length>0"
          >
            <a-select-option v-for="item in getJenisAnggaran" :key="item.value">
              {{
              item.text
              }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="Cost Center">
          <a-select
            :disabled="costCenter.length == 0 || (dataList && dataList.length>0)"
            showSearch
            ref="costCntr"
            v-decorator="[
                  'cost_center',
                  {
                    rules: [{ required: true }],
                    initialValue: initialData.cost_center,
                  },
                ]"
            @change="handleCost"
          >
            <a-select-option v-for="item in costCenter" :key="item.value">
              {{
              item.text}} ({{item.nama_pekerjaan ? item.nama_pekerjaan : '-'}})
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="Peruntukan">
          <a-select
            :disabled="peruntukan.length == 0  || (dataList && dataList.length>0)"
            showSearch
            v-decorator="[
          'peruntukan',
          {
            rules: [{ required: true }],
            initialValue: initialData.peruntukan,
          },
        ]"
            @change="handlePeruntukan"
            optionFilterProp="children"
            :filterOption="filterOption"
          >
            <a-select-option v-for="item in peruntukan" :key="item.value">
              {{
              item.text
              }}
            </a-select-option>
          </a-select>
        </a-form-item> -->

        <a-row :gutter="24">
          <a-col span="0" style="display:none">
            <a-form-item label="Activity Type" v-if="1==0 && (($refs.costCntr && $refs.costCntr.value && $refs.costCntr.value.includes('MARDEV')) || (initialData.cost_center && initialData.cost_center.includes('MARDEV')))">
              <a-select placeholder="Please Select" 
              ref="refactivity_type"
              v-decorator="[
                'type_activity',
                { rules: [{ required: true }], initialValue: initialData.type_activity },
              ]"
              :disabled="(dataList && dataList.length>0) || 1==1"
              @change="changeActivity_type" class="width-full">
                <a-select-option v-for="item in getMARDEVActivity.type" :key="item">
                  {{item}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col span="24">
            <a-form-item label="Activity" v-if="1==0 && (($refs.refactivity_type && $refs.refactivity_type.value=='Non Project') || 'Non Project'==initialData.type_activity)">
              <a-select placeholder="Please Select" 
              v-decorator="[
                'activity',
                { rules: [{ required: true }], initialValue: initialData.activity },
              ]" 
              :disabled="dataList && dataList.length>0"
              class="width-full">
                <a-select-option v-for="item in getMARDEVActivity.activity" :key="item">
                  {{item}}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Pipeline" v-if="1==0 && (($refs.refactivity_type && $refs.refactivity_type.value=='Project Penetration') || 'Project Penetration'==initialData.type_activity)">
              <a-select
                :disabled="dataList && dataList.length>0"
                showSearch
                :loading="load.pipeline"
                :not-found-content="null"
                option-filter-prop="children"
                v-decorator="[
                  'pipeline_id',
                  {
                    rules: [{ required: true }],
                    initialValue: initialData.pipeline_id,
                  },
                ]"
              >
                <a-select-option v-for="item in pipelineList" :key="item.pipeline_id">
                  [{{ item.pipeline_no}}] {{ item.definitions }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>

        <a-form-item label="Approval" style="display:none">
          <a-select
            placeholder="Please select Executive"
            v-decorator="[
              'bod',
              { rules: [{ required: true }], initialValue: initialData.bod },
            ]"
            disabled
          >
            <a-select-option v-for="data in wo_bod" :key="data.value"
              >{{ data.value }} - {{ data.text }}</a-select-option
            >
          </a-select>
        </a-form-item>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
import _ from "lodash";
import CurrencyFormat from "@/mixins/CurrencyFormat";

export default {
  name: "Informasi",
  props: {
    data: {},
    others: {},
    dataList: {},
    mode: String,
    type: String,
    // eslint-disable-next-line vue/require-prop-type-constructor
    active: false,
  },
  mixins:[CurrencyFormat],
  data() {
    return {
      listNoSPPD: [],
      pageLoading: true,
      pic: "",
      pic_name: "",
      bod: "",
      wo_bod: [],
      costCenter: [],
      peruntukan: [],
      pipelineList: [],
      load:{
        pipeline: false
      }
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    this.$store.dispatch("FETCH_COST_CENTER_KD");
    this.$store.dispatch("FETCH_ENDUSER_CC");
    if (this.mode === "Create" && !this.active) {
      // this.listNoSPPD = [];
      this.bod = "ADI";
      this.fetchBodPic();
    } else {
      this.pageLoading = false;
      this.bod = "ADI";
      this.fetchBodPic();
    }

    // this.$store.dispatch("FETCH_ACTIVE_PROJECTKK");
    // axios({
    //   method: "get",
    //   url: this.$serviceUrl + "bod",
    //   params: {
    //     "X-API-KEY": this.getAuth.apikey,
    //   },
    //   auth: {
    //     username: this.getAuth.username,
    //     password: this.getAuth.password,
    //   },
    // })
    //   .then((response) => {
    //     //console.log(response);
    //     this.wo_bod = response.data.bod;
    //   })
    //   .catch((err) => {
    //     this.displayMessage("error-connection");
    //   });
  },
  watch: {
    "getJenisAnggaran"(){
      if(this.data && this.data.jenis_anggaran && this.mode === "Edit")
        this.handleJenisAnggaran(this.data.jenis_anggaran)
    },
    "getCostCenter"(){
      if(this.data && this.data.cost_center && this.mode === "Edit")
        this.handleCost(this.data.cost_center)
    },
    "getPeruntukan"(){
      if(this.data && this.data.peruntukan && this.mode === "Edit")
        this.handlePeruntukan(this.data.peruntukan)
    }
  },
  async mounted(){
    if(this.data){
      await this.handleJenisAnggaran(this.data.jenis_anggaran)
      await this.handleCost(this.data.cost_center)
      await this.handlePeruntukan(this.data.peruntukan)
    }
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getCostCenter",
      "getPeruntukan",
      "getSubPeruntukan",
      "getAnggaran",
      "getJenisAnggaran",
      "getMARDEVActivity",
      "getEndUserCC",
    ]),
    initialData() {
      if (this.data === undefined || this.data.length <= 0) {
        return {
          tanggal_pelaporan: moment(),
          pic: this.pic,
          bod: this.bod,
          catatan: "",
          jenis_anggaran: null,
          cost_center: null,
          peruntukan: null,
          activity: null,
          type_activity: 'Non Project',
          pipeline_id: null,
          id_user_cc: null
        };
      } else {
        return {
          tanggal_pelaporan: moment(this.data.tanggal_pelaporan),
          // bod: this.data.bod ? this.data.bod : null,
          bod: this.bod,
          catatan: this.data.catatan,
          jenis_anggaran: this.data.jenis_anggaran,
          cost_center: this.data.cost_center,
          peruntukan: this.data.peruntukan,
          activity: this.data.activity,
          type_activity: this.data.type_activity,
          pipeline_id: this.data.pipeline_id,
          id_user_cc: this.data.id_user_cc
        };
      }
    },
    getEndUserCCFiltered(){
      return this.informasi && this.informasi.cost_center && this.informasi.cost_center.includes('MARDEV') ? 
        this.getEndUserCC.filter(item=>item.tlc=='ADI') : this.getEndUserCC
    }
  },
  methods: {
    moment,
    fetchPipeline(e) {
      axios({
        method: "get",
        url: this.$serviceUrl + "pp/pipeline",
        params: {
          anggaran_id: e,
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.pipelineList = response.data && response.data.data?response.data.data:[];
          this.pageLoading = false;
        })
        .catch(() => {
        });
    },
    fetchBodPic() {
      axios({
        method: "get",
        url: this.$serviceUrl + "klaim_cc/approval_bod",
        params: {
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.wo_bod = response.data.data;
          this.pageLoading = false;
        })
        .catch((err) => {
          if (err.response.status === 401) {
            if (this.mode === "Create") {
              this.$router.go(-1);
            } else {
              this.pageLoading = false;
              this.loading = false;
            }
          }
        });
    },
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        const selectedPipeline = values.pipeline_id ? _.filter(this.pipelineList,item=>item.pipeline_id==values.pipeline_id)[0]: null

        const informasi = {
          tanggal_pelaporan: values.tanggal_pelaporan,
          bod: values.bod || "",
          catatan: this.initialData.catatan,
          jenis_anggaran: values.jenis_anggaran,
          cost_center: values.cost_center,
          peruntukan: values.peruntukan,
          type_activity: values.type_activity,
          activity: values.activity,
          pipeline_id: values.pipeline_id,
          id_user_cc: values.end_user,
          selectedPipeline: selectedPipeline,
        };
        Event.$emit("kDirekturInformasi", informasi);
      });
    },
    beforeRouteEnter(to, from, next) {
      this.fetchBodPic((err, post) => {
        next();
      });
    },
    clearForm() {
      this.form.resetFields();
    },
    handleBOD(data) {
      let filter = this.wo_bod.filter(
        (obj) => obj.value.toLowerCase().indexOf(data.toLowerCase()) >= 0
      );
    },
    handleJenisAnggaran(e) {
      const filter = this.getCostCenter.filter(
        (obj) => obj.jns_anggaran_id.toLowerCase() == e.toLowerCase()
      );
      this.costCenter = filter;

      const filter2 = filter.filter(
        (obj) => obj.value == this.initialData.cost_center
      )

      this.$nextTick(function () {
        this.form.setFieldsValue({
          cost_center: this.initialData.cost_center && filter2.length>0 ? this.initialData.cost_center :  null,
          peruntukan: this.initialData.peruntukan && filter2.length>0 ? this.initialData.peruntukan :  null,
        });
        // this.$refs.forms.resetFields([
        //   "cost_center",
        //   "peruntukan"
        //   // "sub_peruntukan",
        // ]);
      })

      // this.modalanggaran.enabled = false;
      // this.subPeruntukan = [];
      this.peruntukan = [];
      // this.anggaran.tree = [];
      // this.anggaran.treeModal = [];
    },
    async handleCost(e) {
      // this.form.resetFields(["peruntukan"]);
      this.form.setFieldsValue({
        peruntukan: this.dataList.length>0 ? this.initialData.peruntukan :  null,
      });
      // this.subPeruntukan = [];
      // this.anggaran.tree = [];
      // this.anggaran.treeModal = [];
      const peruntukan = this.getPeruntukan.filter(
        (obj) => obj.anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );
      this.peruntukan = peruntukan;

      // this.anggaran.anggaran_id = e;
      this.fetchPipeline(e)
    },
    handlePeruntukan(){

    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    changeActivity_type(val){
      console.log("changeActivity_type",val)
      if(val=="Non Project"){
        this.$nextTick(function () {
          this.form.setFieldsValue({
            activity: null,
          });
        });
      }else{
        this.$nextTick(function () {
          this.form.setFieldsValue({
              pipeline_id: null,
          });
        });
      }
    },
    filterOptionTlc(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
  },
};
</script>

<style></style>
